import * as React from 'react';
import WelcomeComponent from "../components/WelcomeComponent/WelcomeComponent";

export interface IWelcomeProps {
    history: any,
}

class WelcomeContainer extends React.PureComponent<IWelcomeProps> {
    public render() {
        return (
            <WelcomeComponent {...this.props}/>
        );
    }
}

export default WelcomeContainer


// WEBPACK FOOTER //
// ./src/containers/WelcomeContainer.tsx